var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class ContactsApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'contacts';
    }
    getAllContacts() {
        return __awaiter(this, arguments, void 0, function* (filters = {}, params = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}`, params: filters }, params));
        });
    }
    getOneContact(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, params = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/${id}` }, params));
        });
    }
    createContact(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data: payload,
            });
        });
    }
    updateContact(id, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${id}`,
                data: payload,
            });
        });
    }
    deleteContact(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}/${id}`,
            });
        });
    }
}
//# sourceMappingURL=index.js.map